import { HttpClient } from 'helpers/http-client/apiClient';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
interface AuthMiddlewareProps {
  children: React.ReactNode;
}

const AuthMiddleware: React.FC<AuthMiddlewareProps> = ({ children }) => {
  const location = useLocation();
  const credentials = HttpClient.getAuthCredentials();

  if (!credentials?.token) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default AuthMiddleware;
